import {FileCard} from '@features/files/FileCard';
import {Stack} from '@mui/material';
import {FileEntity} from '@pages/FilesPage';
import {IncidentService} from '@services/IncidentService/IncidentService';
import {FileUploadAreaBox} from '@ui/FileUploadArea/FileUploadAreaBox';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FILE_UPLOAD_MAX_SIZE_MB} from 'utils';

const service = IncidentService;

export const TechnicalSupportModalFiles = ({setFiles}: {setFiles: (files: string[]) => void}) => {
    const {t} = useTranslation(['supervising', 'common']);
    const [error, setError] = useState<string | null>(null);
    const [filesToUpload, setFilesToUpload] = useState<FileEntity[]>([]);

    useEffect(() => {
        setFiles(filesToUpload.map((file) => file.id));
    }, [filesToUpload, setFiles]);

    const handleDeleteFile = (fileId: string) => {
        setFilesToUpload((prev) => {
            if (prev) {
                return prev.filter((file) => file.id !== fileId);
            }
            return [];
        });
    };

    const uploadSingleFile = async (fileData: {file: File}) => {
        const {file} = fileData;

        if (file.size > FILE_UPLOAD_MAX_SIZE_MB * 1024 * 1024) {
            setError(`${t('fileIsMore', {filename: file.name})} ${FILE_UPLOAD_MAX_SIZE_MB} MB`);
            return;
        }

        setError(null);
        const formData = new FormData();
        formData.append('file', file, file.name);

        await service.createFile(formData, {}).then((resp) => {
            const data = resp.data;
            setFilesToUpload((prev) => {
                if (prev) {
                    return [...prev, data];
                }
                return [data];
            });
        });
    };

    const onUploadFiles = (files: File[]) => {
        files.forEach((file) => uploadSingleFile({file}));
    };

    return (
        <Stack>
            <FileUploadAreaBox
                onUploadFiles={onUploadFiles}
                error={error}
            />
            {filesToUpload.map((file) => (
                <FileCard
                    key={file.id}
                    category={null}
                    file={
                        {
                            ...file,
                            originalFilename: file.filename || '',
                            _links: {},
                        } as FileEntity
                    }
                    width='100%'
                    onDelete={handleDeleteFile}
                    needEdit={false}
                />
            ))}
        </Stack>
    );
};
